import {
  M8PartnerSortableField,
  M8PaginationParams,
} from 'services/production/types';
import { PartnersPageDataServiceParams } from 'types/services';
import { normalizePartnersTableSortableField } from 'services/production/utils/normalizePartnersTableSortableField';

export const normalizePartnersPageDataServiceParams = (
  params: PartnersPageDataServiceParams
) => ({
  toM8GetPartnersPageParams(): M8PaginationParams<M8PartnerSortableField> {
    return {
      page: params.page - 1,
      size: params.pageSize,
      sort: normalizePartnersTableSortableField(
        params.sorting.field
      ).toM8PartnerSortableField(),
      order: params.sorting.ascending ? 'ASC' : 'DESC',
      startWith: params.searchBy || '',
    };
  },
});
